import React from 'react';
import { Link } from 'react-router-dom';
import { Zap, CheckCircle, ArrowRight, ArrowLeft, Clock, Users, Target } from 'lucide-react';

const StressManagementPage = () => {
  const topics = [
    'Kas yra stresas ir kaip jis veikia mūsų kūną bei protą',
    'Streso atpažinimo požymiai ir simptomai',
    'Praktinės streso valdymo technikos',
    'Kaip išlaikyti pusiausvyrą įtemptose situacijose',
    'Ilgalaikės strategijos streso prevencijai'
  ];

  const benefits = [
    'Išmoksite atpažinti streso požymius ankstyvoje stadijoje',
    'Įgysite praktinių įrankių streso valdymui',
    'Pagerinsite darbo ir asmeninio gyvenimo balansą',
    'Sustiprinsite atsparumą stresui'
  ];

  return (
    <div className="min-h-screen">
      {/* Header */}
      <section className="bg-[#FF9F43] py-16 md:py-24">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <Link 
            to="/mokymai" 
            className="inline-flex items-center text-white/90 hover:text-white mb-8 transition-colors"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Grįžti į visus mokymus
          </Link>
          
          <div className="flex items-center space-x-4 mb-6">
            <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center">
              <Zap className="w-10 h-10 text-white" />
            </div>
            <h1 className="text-4xl md:text-5xl font-['Poppins'] font-bold text-white">
              Streso valdymo mokymai
            </h1>
          </div>
          <p className="text-xl text-white/90 leading-relaxed">
            Praktiniai įrankiai kasdieniam streso valdymui
          </p>
        </div>
      </section>

      {/* Quick Info */}
      <section className="py-8 bg-white border-b border-slate-100">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <div className="flex flex-wrap gap-6 justify-center">
            <div className="flex items-center space-x-2 text-[#718096]">
              <Clock className="w-5 h-5 text-[#FF9F43]" />
              <span>4-8 akademinės valandos</span>
            </div>
            <div className="flex items-center space-x-2 text-[#718096]">
              <Users className="w-5 h-5 text-[#4CAF50]" />
              <span>Visiems darbuotojams</span>
            </div>
            <div className="flex items-center space-x-2 text-[#718096]">
              <Target className="w-5 h-5 text-[#5B9BD5]" />
              <span>Praktinės technikos</span>
            </div>
          </div>
        </div>
      </section>

      {/* Topics */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <h2 className="text-3xl font-['Poppins'] font-bold text-[#2D3748] mb-8 text-center">
            Mokymų temos
          </h2>
          <div className="space-y-4">
            {topics.map((topic, index) => (
              <div
                key={index}
                className="flex items-start space-x-4 bg-[#FFF3E0] p-5 rounded-2xl hover:bg-[#FF9F43]/20 transition-colors"
              >
                <div className="w-8 h-8 rounded-full bg-[#FF9F43] text-white flex items-center justify-center flex-shrink-0 font-semibold text-sm">
                  {index + 1}
                </div>
                <p className="text-[#718096] leading-relaxed">{topic}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits */}
      <section className="py-16 bg-[#FAFAF8]">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl">
          <h2 className="text-3xl font-['Poppins'] font-bold text-[#2D3748] mb-8 text-center">
            Ko išmoksite?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {benefits.map((benefit, index) => (
              <div
                key={index}
                className="flex items-start space-x-3 bg-white p-5 rounded-2xl border border-slate-100"
              >
                <CheckCircle className="w-6 h-6 text-[#FF9F43] flex-shrink-0 mt-0.5" />
                <p className="text-[#718096]">{benefit}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="bg-[#FF9F43] py-16">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl text-center">
          <h2 className="text-3xl font-['Poppins'] font-bold text-white mb-4">
            Norite užsisakyti šiuos mokymus?
          </h2>
          <p className="text-xl text-white/90 mb-8">
            Susisiekite ir aptarkime, kaip galiu padėti jūsų komandai
          </p>
          <Link
            to="/kontaktai"
            className="inline-flex items-center bg-white text-[#FF9F43] hover:bg-slate-100 rounded-full px-8 py-4 font-semibold transition-colors"
          >
            Gauti pasiūlymą
            <ArrowRight className="w-5 h-5 ml-2" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default StressManagementPage;
